class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endDateStr = this.getAttribute('data-end-date');
    this.endTime = new Date(this.endDateStr).getTime();
    
    // Fallback: If your date string doesn't have the offset, 
    // you can force it in JS by replacing spaces with 'T' and adding -05:00
    // this.endTime = new Date(this.endDateStr.replace(' ', 'T') + '-05:00').getTime();

    this.updateTimer();
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.endTime - now;

    if (distance < 0) {
      clearInterval(this.interval);
      this.querySelector('.countdown-timer').style.display = 'none';
      this.querySelector('.countdown-expired').style.display = 'block';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.querySelector('[data-days]').textContent = days.toString().padStart(2, '0');
    this.querySelector('[data-hours]').textContent = hours.toString().padStart(2, '0');
    this.querySelector('[data-minutes]').textContent = minutes.toString().padStart(2, '0');
    this.querySelector('[data-seconds]').textContent = seconds.toString().padStart(2, '0');
  }
}

customElements.define('countdown-timer', CountdownTimer);